import ContactForm from "./ContactForm/ContactForm";
import GalleryLoader from "./Gallery/GalleryLoader";
import hyphens from "./hyphens/hyphens";

$(document).ready(function () {
	initStickyHeader();
	initLocationsSwitcher();
	initLanguagesSwitcher();
	initMenuTrigger();
	initNewsSlider();
	initNewsCarousel();
	initSubscribePopup();
	initSmoothZoom();
	initLocationTabs();
	initMapsTabs();
	initVideoDirections();
	initBuildingSlider();
	initAnchors();
	initLightbox();
	initStandardSlider();
	initOfficeFeaturesCarousel();
	initLocationCarousel();
	initBoxesCarousel();
	initcontactSiteplanHover();
	new ContactForm();
	new GalleryLoader();
	hyphens()
});

function initStickyHeader() {
	let menu = document.querySelector(".header");
	let origOffsetY = menu.offsetTop;
	
	function scroll() {
		if ($(window).scrollTop() > origOffsetY) {
			$(".header").addClass("scrolling");
		} else {
			$(".header").removeClass("scrolling");
		}
	}
	
	scroll();
	document.onscroll = scroll;
}

function initLocationsSwitcher() {
	$(".header__switcher").on("click", function () {
		$(this).stop(true, true).toggleClass("visible");
		$(".header__locations").stop(true, true).toggleClass("visible");
	});
}

function initLanguagesSwitcher() {
	$(".languages__current").on("click", function () {
		$(".header__languages").stop(true, true).toggleClass("visible");
		if ($(window).width() > 1024) {
			$(".languages__list").stop(true, true).fadeToggle();
		} else {
			$(".languages__list").stop(true, true).slideToggle();
		}
	});
}

function initMenuTrigger() {
	$(".header__trigger").on("click", function () {
		$(this).toggleClass("visible");
		$(".header__options").slideToggle();
	});
}

function initNewsSlider() {
	const newsSliderVisible = document.querySelector(".news__slider");
	if (newsSliderVisible) {
		let newsSlider = new Swiper(".news__slider", {
			effect: "fade",
			autoHeight: true,
			loop: true,
			autoplay: {
				delay: 3000,
				// stopOnLastSlide: true
			},
			navigation: {
				prevEl: ".slide__navigation__button--prev",
				nextEl: ".slide__navigation__button--next"
			}
			// pagination: {
			//   el: ".slider__pagination",
			//   clickable: true
			// }
		});
	}
}

function initNewsCarousel() {
	const newsCarouselVisible = document.querySelector(".news__carousel");
	if (newsCarouselVisible) {
		let newsContainerCurrent = document.querySelector(".swiper-counter .current-slide");
		let newsContainerTotal = document.querySelector(".swiper-counter .total-slides");
		let newsContainer = new Swiper(".news__carousel", {
			init: false,
			autoplay: {
				delay: 99999999,
				disableOnInteraction: false
			},
			autoHeight: true,
			navigation: {
				prevEl: ".carousel__navigation .navigation__prev",
				nextEl: ".carousel__navigation .navigation__next"
			},
			breakpoints: {
				560: {
					autoplay: {
						delay: 5000
					}
				}
			}
		});
		newsContainer.on("init", function () {
			newsContainerCurrent.innerHTML = newsContainer.activeIndex + 1;
			newsContainerTotal.innerHTML = newsContainer.slides.length;
		});
		newsContainer.on("slideChange", function () {
			newsContainerCurrent.innerHTML = newsContainer.activeIndex + 1;
		});
		newsContainer.init();
	}
}

function initSubscribePopup() {
	const subscribePopup = document.querySelector(".post-page__newsletterPopup");
	if (subscribePopup) {
		$('.post-page__header .header__info .info__newsletter').on('click', function (e) {
			e.preventDefault();
			$('.post-page__newsletterPopup').stop(true, true).addClass('active');
		});
		$('.post-page__newsletterPopup .newsletterPopup__close').on('click', function (e) {
			$(this).parent().stop(true, true).removeClass('active');
		});
	}
}

function initSmoothZoom() {
	const mapsExist = document.querySelector(".location-page");
	if (mapsExist) {
		
		$("#cityMap").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		
		$("#amenitiesMap").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		
		$("#connectivityMapBus").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		$("#connectivityMapTram").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		$("#connectivityMapBike").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		$("#connectivityMapTrain").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		$("#connectivityMapCar").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		$("#connectivityMapPlane").smoothZoom({
			background_COLOR: '#F2F2F2',
			zoom_OUT_TO_FIT: "NO",
			pan_BUTTONS_SHOW: "NO",
			animation_SMOOTHNESS: 8,
			animation_SPEED_ZOOM: 1,
			animation_SPEED_PAN: 5,
			button_SIZE: 60,
			button_ALIGN: "bottom right",
			button_BG_TRANSPARENCY: 0,
			button_ROUND_CORNERS: false,
			button_MARGIN: 0,
			zoom_MAX: 100,
			border_SIZE: 0
		});
		
	}
}

function initLocationTabs() {
	const locationTabsVisible = document.querySelector(".location-page");
	if (locationTabsVisible) {
		var triggers = $(".location-page__tabs li");
		$(triggers).on("click", function (e) {
			e.preventDefault();
			var clickEl = e.target.closest("li") || e.target;
			var target = clickEl.getAttribute("data-id");
			switchBtn(clickEl);
			switchTab(target);
		});
		
		function switchBtn(clickEl) {
			var active = $(".location-page__tabs li.active");
			$(clickEl).addClass("active");
			$(active).removeClass("active");
		}
		
		function switchTab(target) {
			var active = $(".location-page__item.active");
			var next = $("#" + target);
			$(active).fadeOut(400, function () {
				$(next).fadeIn(0).addClass("active");
			}).removeClass("active");
		}
	}
}

function initMapsTabs() {
	const locationTabsVisible = document.querySelector(".location-page");
	if (locationTabsVisible) {
		var triggers = $(".maps .maps__tabs li");
		$(triggers).on("click", function (e) {
			e.preventDefault();
			var clickEl = e.target.closest("li") || e.target;
			var target = clickEl.getAttribute("data-id");
			switchBtn(clickEl);
			switchTab(target);
		});
		
		function switchBtn(clickEl) {
			var active = $(".maps .maps__tabs li.active");
			$(clickEl).addClass("active");
			$(active).removeClass("active");
		}
		
		function switchTab(target) {
			var active = $(".maps .maps__wrapper .maps__item.active");
			var next = $("#" + target);
			$(active).fadeOut(400, function () {
				$(next).fadeIn(0).addClass("active");
			}).removeClass("active");
		}
	}
}

function initVideoDirections() {
	const locationTabsVisible = document.querySelector(".location-page");
	if (locationTabsVisible) {
		$('.maps__tabs div.video, .map__address .address__video').on('click', function (e) {
			e.preventDefault();
			$('.location-page__videoPopup').stop(true, true).addClass('active');
		});
		$('.location-page__videoPopup .videoPopup__close').on('click', function (e) {
			$(this).parent().stop(true, true).removeClass('active');
		});
	}
}

function initBuildingSlider() {
	const buildingSliderVisible = document.querySelector(".building__slider");
	if (buildingSliderVisible) {
		let buildingSlider = new Swiper(".building__slider", {
			effect: "fade",
			navigation: {
				prevEl: ".slider__navigation .navigation__prev",
				nextEl: ".slider__navigation .navigation__next"
			}
		});
	}
}

function initAnchors() {
	const anchorsVisible = document.querySelector(".scroll-init");
	if (anchorsVisible) {
		$(".scroll-init").on("click", function (e) {
			e.preventDefault();
			$("html, body").animate({scrollTop: $($(this).attr("href")).offset().top}, 800);
		});
	}
}

function initLightbox() {
	const lightboxVisible = document.querySelector("a.lightbox-photo-global");
	if (lightboxVisible) {
		let lightbox = $("a.lightbox-photo-global").simpleLightbox({
			widthRatio: 0.9,
			heightRatio: 0.825,
			navText: ["", ""],
			closeText: [""],
			showCounter: false,
			scaleImageToRatio: true,
			additionalHtml: [
				'<a class="lightbox-photo-destiny" href="" download></a>'
			]
		});
		$("a.lightbox-photo-global").on("change.simplelightbox", e => {
			handlePhotoChange(e);
		});
		$("a.lightbox-photo-global").on("shown.simplelightbox", e => {
			handlePhotoChange(e);
		});
	}
}

function handlePhotoChange(e) {
	const url = e.target.getAttribute("data-full");
	const download = document.querySelector(".lightbox-photo-destiny");
	download.setAttribute("href", url);
}

function initStandardSlider() {
	const standardSliderVisible = document.querySelector(".standard__slider");
	if (standardSliderVisible) {
		let standardSliderThumbs = new Swiper(".standard__thumbnails .thumbnails__carousel", {
				slidesPerView: "auto",
				watchSlidesVisibility: true,
				watchSlidesProgress: true
			}
		);
		let standardSlider = new Swiper(".standard__slider", {
			effect: "fade",
			autoHeight: true,
			navigation: {
				nextEl: ".slider__navigation .swiper-button-next",
				prevEl: ".slider__navigation .swiper-button-prev"
			},
			pagination: {
				el: ".slider__pagination",
				clickable: true
			},
			thumbs: {
				swiper: standardSliderThumbs
			}
		});
	}
}

function initOfficeFeaturesCarousel() {
	const officeFeaturesCarouselVisible = document.querySelector(".features__carousel");
	if (officeFeaturesCarouselVisible) {
		let officeFeaturesCarousel = new Swiper(".features__carousel", {
			slidesPerView: 2,
			navigation: {
				prevEl: ".carousel__navigation .navigation__prev",
				nextEl: ".carousel__navigation .navigation__next"
			}
		});
	}
}

function initLocationCarousel() {
	const locationCarouselVisible = document.querySelector(".carousel__transport-types");
	if (locationCarouselVisible) {
		let locationCarousel = new Swiper(".carousel__transport-types", {
			spaceBetween: 15,
			autoHeight: true,
			observer: true,
			observeParents: true
		});
	}
}

function initBoxesCarousel() {
	const boxesCarouselVisible = document.querySelector(".news-boxes__carousel");
	if (boxesCarouselVisible) {
		let boxesCarouselCurrent = document.querySelector(".news-boxes__carousel .carousel__counter .current-slide");
		let boxesCarouselTotal = document.querySelector(".news-boxes__carousel .carousel__counter .total-slides");
		let boxesCarousel = new Swiper(".news-boxes__carousel", {
			init: false,
			spaceBetween: 15,
			autoHeight: true,
			observer: true,
			observeParents: true
		});
		boxesCarousel.on("init", function () {
			boxesCarouselCurrent.innerHTML = boxesCarousel.activeIndex + 1;
			boxesCarouselTotal.innerHTML = boxesCarousel.slides.length;
		});
		boxesCarousel.on("slideChange", function () {
			boxesCarouselCurrent.innerHTML = boxesCarousel.activeIndex + 1;
		});
		boxesCarousel.init();
	}
}

function initcontactSiteplanHover() {
	const contactSiteplanHover = document.querySelector('.contact-page__content');
	if (contactSiteplanHover) {
		$('#phase-1')
			.mouseover(function () {
				$('.contact-page__content .content__center svg').stop(true, true).addClass('phase-1-hover').promise().done();
			})
			.mouseout(function () {
				$('.contact-page__content .content__center svg').stop(true, true).removeClass('phase-1-hover').promise().done();
			});
		$('#phase-2')
			.mouseover(function () {
				$('.contact-page__content .content__center svg').stop(true, true).addClass('phase-2-hover').promise().done();
			})
			.mouseout(function () {
				$('.contact-page__content .content__center svg').stop(true, true).removeClass('phase-2-hover').promise().done();
			});
	}
}
